import { Hotel, HotelFragmentFragment } from '../generated/types';
import { useMemo } from 'react';
import { filterDuplicatedByEntityId } from '../utils/helper';

export default function useHotelNearData(data: HotelFragmentFragment) {
  return useMemo(() => {
    return {
      hotelNearActivities: filterDuplicatedByEntityId(
        data.nearActivities?.items || [],
        data.activities || []
      ),
      hotelNearPois: filterDuplicatedByEntityId(
        data.nearPois?.items || [],
        data.pois || []
      ),
    };
  }, [data]);
}
